<app-landing-top-app-bar
  [user$]="user$"
  [showBalance]="false"
  [showBilling]="false"
  [logoLink]="null"
  (signOut)="signOut()"
  (switchAccount)="switchAccount()"
></app-landing-top-app-bar>

<div class="unauthorized-container" data-testid="unauthorized-state">
  <div class="unauthorized-card">
    <div class="unauthorized-icon">
      <mat-icon>block</mat-icon>
    </div>

    <h2 #statusHeading data-testid="unauthorized-heading" tabindex="-1">Authorization Required</h2>
    <p class="subtitle">Access denied</p>

    <div class="unauthorized-content">
      <p>Thanks for expressing interest in our application.</p>
      @if (denialMessage) {
        <p data-testid="authorization-denial-message">{{ denialMessage }}</p>
      }
      @if (email) {
        <p>
          You are logged in with the Google Account of:
          <strong>{{ email }}</strong>
        </p>
      }

      <!-- Standard "Not Allowlisted" Message -->
      @if ((authorizationError$ | async) === null) {
        <p>This account is not yet allowlisted for access.</p>
        <div class="what-to-do">
          <strong>What you can do next:</strong>
          <ul>
            <li>Request access using the link below</li>
            <li>
              Contact support at
              <a href="mailto:info@permitproof.com">info&#64;permitproof.com</a>
            </li>
            <li>Try signing in with a different Google account</li>
          </ul>
        </div>
        <p class="access-request">
          Please request access
          <a
            href="https://docs.google.com/forms/d/1mBpVhJ7DrnNGiVDOpBF0BNGWnbwY-fn0BavYE0svw48/viewform"
            target="_blank"
          >
            here
          </a>
          .
        </p>
      }

      <!-- Server Configuration Error Message -->
      @if (authorizationError$ | async; as errorMessage) {
        <p><strong>Unable to check the allowlist for your account.</strong></p>
        <p>This may be a temporary server issue. Please try again later or contact support if the problem persists.</p>
        <mat-expansion-panel class="technical-details">
          <mat-expansion-panel-header>
            <mat-panel-title>Technical Details</mat-panel-title>
          </mat-expansion-panel-header>
          <pre class="error-details">{{ errorMessage }}</pre>
        </mat-expansion-panel>
      }
    </div>

    <div class="unauthorized-actions">
      <button mat-raised-button color="primary" (click)="switchAccount()">
        <mat-icon>swap_horiz</mat-icon>
        Switch Account
      </button>
      <button mat-stroked-button (click)="signOut()">
        <mat-icon>logout</mat-icon>
        Sign Out
      </button>
    </div>
  </div>
</div>
